export default "__VITE_ASSET__2He7Vmax__"